import {getElementByTagName} from "../utils";

const createImages = (hash) => {
    const main = getElementByTagName('main');

    for (let item of Array.from(main.childNodes)) {
        if (item.nodeName === 'IMG') {
            main.removeChild(item);
        }
    }

    const imagesFragment = document.createDocumentFragment();

    for (let i = 0; i < 3; i++) {
        const img = document.createElement('img');
        img.src = generateImagePath(hash, i + 1);
        img.classList.add('image');

        if (i !== 0) {
            img.classList.add('hide');
        }

        imagesFragment.append(img);
    }

    main.append(imagesFragment);
};

const generateImagePath = (hash, imageId) => `/images/${hash}_${imageId}.jpeg`;

export default createImages;
